// @flow

import React, { PureComponent } from "react";
import styled from "styled-components";

const SVG = styled.svg`
  display: block;
  height: 135px;
`;

export default class CarrerTop extends PureComponent<*> {
  render() {
    let windowLocation = "";
    if (typeof window !== "undefined") {
      windowLocation = window.location.href;
    }
    return (
      <SVG viewBox="0 0 374 134">
        <defs>
          <filter
            x="-.1%"
            y="-.4%"
            width="100.3%"
            height="100.7%"
            filterUnits="objectBoundingBox"
            id="b"
          >
            <feOffset dy="-1" in="SourceAlpha" result="shadowOffsetInner1" />
            <feComposite
              in="shadowOffsetInner1"
              in2="SourceAlpha"
              operator="arithmetic"
              k2="-1"
              k3="1"
              result="shadowInnerInner1"
            />
            <feColorMatrix
              values="0 0 0 0 0.811764706 0 0 0 0 0.839215686 0 0 0 0 0.858823529 0 0 0 1 0"
              in="shadowInnerInner1"
            />
          </filter>
          <filter
            x="0%"
            y="0%"
            width="100%"
            height="100%"
            filterUnits="objectBoundingBox"
            id="c"
          >
            <feGaussianBlur in="SourceGraphic" />
          </filter>
          <filter
            x="0%"
            y="0%"
            width="100%"
            height="100%"
            filterUnits="objectBoundingBox"
            id="d"
          >
            <feGaussianBlur in="SourceGraphic" />
          </filter>
          <filter
            x="0%"
            y="0%"
            width="100%"
            height="100%"
            filterUnits="objectBoundingBox"
            id="e"
          >
            <feGaussianBlur in="SourceGraphic" />
          </filter>
          <linearGradient x1="0%" y1="34.988%" x2="88.738%" y2="66.304%" id="f">
            <stop stopColor="#CFD6DB" offset="0%" />
            <stop stopColor="#F0F3F8" offset="53.204%" />
            <stop stopColor="#CFD6DB" offset="53.692%" />
            <stop stopColor="#CFD6DB" offset="100%" />
          </linearGradient>
          <linearGradient x1="0%" y1="34.568%" x2="88.738%" y2="66.76%" id="g">
            <stop stopColor="#F99F4A" offset="0%" />
            <stop stopColor="#FFB773" offset="47.316%" />
            <stop stopColor="#F99F4A" offset="47.928%" />
            <stop stopColor="#F99F4A" offset="100%" />
          </linearGradient>
          <linearGradient x1="0%" y1="39.875%" x2="88.738%" y2="60.996%" id="h">
            <stop stopColor="#FFCB4D" offset="0%" />
            <stop stopColor="#FFD87A" offset="53.328%" />
            <stop stopColor="#FFCB4D" offset="53.692%" />
            <stop stopColor="#FFCB4D" offset="100%" />
          </linearGradient>
          <path id="a" d="M0 0h375v134H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <use fill="#F8FBFF" xlinkHref="#a" />
          <use fill="#000" filter={`url(${windowLocation}#b)`} xlinkHref="#a" />
          <ellipse
            fill="#EBF6FF"
            filter={`url(${windowLocation}#c)`}
            cx="188"
            cy="110"
            rx="40"
            ry="3"
          />
          <ellipse
            fill="#EBF6FF"
            filter={`url(${windowLocation}#d)`}
            cx="80.5"
            cy="110"
            rx="36.5"
            ry="3"
          />
          <ellipse
            fill="#EBF6FF"
            filter={`url(${windowLocation}#e)`}
            cx="295.5"
            cy="110"
            rx="36.5"
            ry="3"
          />
          <text
            stroke="#99A8B1"
            fill={`url(${windowLocation}#f)`}
            fillRule="nonzero"
            fontFamily="Shentox-Bold, Shentox"
            fontSize="40"
            fontWeight="bold"
          >
            <tspan x="44" y="87">
              2ND
            </tspan>
          </text>
          <text
            stroke="#BF7127"
            fill={`url(${windowLocation}#g)`}
            fillRule="nonzero"
            fontFamily="Shentox-Bold, Shentox"
            fontSize="40"
            fontWeight="bold"
          >
            <tspan x="260" y="87">
              3RD
            </tspan>
          </text>
          <path
            d="M171.041 86.796H148v-6.792h7.784V57.996H148v-6.792h15.67v28.8h7.371v6.792zm3.35-22.928v-5.362c0-2.417.654-4.272 1.96-5.566 1.305-1.293 3.178-1.94 5.618-1.94h10.052c2.37 0 4.192.647 5.464 1.94 1.271 1.294 1.907 3.15 1.907 5.566v3.524h-7.784v-3.217c0-.851-.43-1.277-1.288-1.277h-6.856c-.86 0-1.289.426-1.289 1.277v3.676c0 .477.078.809.232.996.155.187.456.349.902.485l11.444 2.91c3.367.886 5.051 2.911 5.051 6.077v6.537c0 2.417-.653 4.272-1.959 5.566-1.305 1.293-3.178 1.94-5.618 1.94h-10.773c-2.372 0-4.193-.647-5.464-1.94-1.272-1.294-1.908-3.15-1.908-5.566v-3.217h7.784v2.91c0 .851.43 1.277 1.289 1.277h7.525c.86 0 1.29-.426 1.29-1.277v-4.442c0-.75-.413-1.226-1.238-1.43l-11.753-3.013c-3.058-.783-4.587-2.928-4.587-6.434zM228 57.996h-8.454v28.8h-7.886v-28.8h-8.505v-6.792H228v6.792z"
            fill="#E8B436"
            fillRule="nonzero"
          />
          <path
            d="M171.041 84.796H148v-6.792h7.784V55.996H148v-6.792h15.67v28.8h7.371v6.792zm3.35-22.928v-5.362c0-2.417.654-4.272 1.96-5.566 1.305-1.293 3.178-1.94 5.618-1.94h10.052c2.37 0 4.192.647 5.464 1.94 1.271 1.294 1.907 3.15 1.907 5.566v3.524h-7.784v-3.217c0-.851-.43-1.277-1.288-1.277h-6.856c-.86 0-1.289.426-1.289 1.277v3.676c0 .477.078.809.232.996.155.187.456.349.902.485l11.444 2.91c3.367.886 5.051 2.911 5.051 6.077v6.537c0 2.417-.653 4.272-1.959 5.566-1.305 1.293-3.178 1.94-5.618 1.94h-10.773c-2.372 0-4.193-.647-5.464-1.94-1.272-1.294-1.908-3.15-1.908-5.566v-3.217h7.784v2.91c0 .851.43 1.277 1.289 1.277h7.525c.86 0 1.29-.426 1.29-1.277v-4.442c0-.75-.413-1.226-1.238-1.43l-11.753-3.013c-3.058-.783-4.587-2.928-4.587-6.434zM228 55.996h-8.454v28.8h-7.886v-28.8h-8.505v-6.792H228v6.792z"
            stroke="#E8B436"
            fill={`url(${windowLocation}#h)`}
            fillRule="nonzero"
          />
        </g>
      </SVG>
    );
  }
}
